<label *ngIf="label" class="readonly-label field-label" type="text">
  {{ label }}
</label>

<div class="readonly-value-wrapper">
  <a
    *ngIf="type === 'link'"
    i2gButton
    buttonStyle="tertiary"
    class="link"
    target="_blank"
    [href]="formattedInput"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    {{ value }}
  </a>
  <p *ngIf="type !== 'link'" class="text">
    {{ formattedInput }}
  </p>
</div>
